import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { backgroundImageSelector } from '../../store/selectors/globalConfigSelectors';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SideNav from '@hid-galaxy-ui/galaxy-react/components/SideNav';
import AppError from '../../components/AppError/AppError';
import styles from './MainTemplate.module.scss';
import {
  appErrorSelector,
  loaderSelector,
  serverErrorMessageSelector,
} from '../../store/selectors/appSelectors';
import { Typography } from '@hid-galaxy-ui/galaxy-react';
import cx from 'classnames';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';
import { userFirstNameSelector } from '../../store/selectors/userSelectors';
import { isAuthenticated } from '../../utils/authService';
import { myFormsPath, myRequestsPath, requestDetailsPath } from '../../utils/paths';
import { SERVER_ERRORS } from '../../constants/backendResponse';
import { useHistory } from 'react-router-dom';
import buildPATHS from '../../utils/paths';
import PageLoader from '../../components/PageLoader';
import { getTranslation } from '../../utils/functions';

const useStyles = (backgroundImage) =>
  makeStyles((theme) => ({
    root: {
      display: 'flex',
      'min-height': '100vh',
      flexDirection: 'column',
      position: 'relative',
      overflowY: 'auto',
      zIndex: '999',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      // scrollbarColor: `${theme.palette.primary.main} transparent`,
      // scrollbarWidth: 'thin',
    },
  }));

const MainTemplate = ({ children }) => {
  const backgroundImage = useSelector(backgroundImageSelector);
  const classes = useStyles(backgroundImage)();
  const appError = useSelector(appErrorSelector);
  const { firstName } = useSelector((state) => ({
    firstName: userFirstNameSelector(state),
  }));

  const showLoader = useSelector(loaderSelector);

  const serverErrorMessage = useSelector(serverErrorMessageSelector);
  const history = useHistory();
  const PATHS = buildPATHS();
  const location = useLocation();

  if (serverErrorMessage === SERVER_ERRORS.UNAUTHORIZED) {
    history.push(PATHS.login);
  }

  const getSelectedNavItem = () => {
    const trimmedPathname = location.pathname.replace('/', '');
    if (trimmedPathname === myFormsPath) {
      return 'myForms';
    } else if (trimmedPathname === myRequestsPath) {
      return 'myRequests';
    }
    
    return '';
  };

  const onNodeClick = (e, key) => {
    switch (key) {
      case 'myRequests':
        history.push(PATHS.my_requests);
        break;
      case 'myForms':
        history.push(PATHS.my_forms);
        break;
    }
  };

  const rensedSideBar = () => {
    return (
      <div className={styles.sideNavContainer}>
        <SideNav
        selected={getSelectedNavItem()}
          navItems={[
            {
              iconName: 'bookBookmark',
              key: 'my_forms',
              subNavItems: [
              
                {
                  key: 'myForms',
                  title: getTranslation('MY_FORMS'),
                },
              ],
              title: getTranslation('FORMS'),
            },
            {
              iconName: 'addressCard',
              key: 'requests',
              subNavItems: [
                {
                  key: 'myRequests',
                  title: getTranslation('MY_REQUESTS'),
                }
              ],
              title: getTranslation('REQUESTS'),
            },
           
          ]}
          onNodeClick={(e, key) => onNodeClick(e, key)}
          isToggle={false}
        />
      </div>
    );
  };

  const renderWelcomeText = () => {
    return (
      <div className="hid-grid hid-spacing__p-05">
        <div className="hid-grid__column hid-grid__column--12-xs">
          <Typography variant={TypographyVariantEnum.H1}>{`Welcome ${firstName}`}</Typography>
        </div>
      </div>
    );
  };
  const renderMainContent = () => {
    return (
      <>
        <div className={styles.mainContainer}>
          { isAuthenticated() && rensedSideBar()}

          <div className={styles.contentContainer}>
            {/* {isAuthenticated() && renderWelcomeText()} */}

            {children}
          </div>
        </div>
      </>
    );
  };
  return (
    <main className={cx(classes.root, 'hid-full-height')}>
      <Header />
      {appError ? <AppError /> : renderMainContent()}
      {showLoader && <PageLoader />}
      {<Footer />}
    </main>
  );
};

export default MainTemplate;
